import React from 'react'
import styled from 'styled-components'
import useGetMajorCustomersQuery from '../../hooks/useMajorCustomers/useGetMajorCustomersQuery'

function Customers() {
  const {data: majorCustomer} = useGetMajorCustomersQuery()
  const majorCustomers = majorCustomer?.data.map((customer: {businessImage: string}) => ({
    businessImage: customer.businessImage
  }))

  const customerImage =
    majorCustomers &&
    majorCustomers.map((image: {businessImage: string}) => (
      <Customer key={image.businessImage}>
        <img src={image.businessImage} alt="business" />
      </Customer>
    ))

  const businessArr = [
    'ajoumotor.png',
    'chonnam.png',
    'dcu.png',
    'dongguk.png',
    'fourseason.png',
    'golfzone.png',
    'hanwha.png',
    'kabnk.png'
  ]
  const DummyImage = businessArr.map((arr) => (
    <Customer key="business">
      <img src={`/assets/images/${arr}`} alt="businessImg" />
    </Customer>
  ))

  return (
    <Wrapper>
      <CustomersArea>{DummyImage}</CustomersArea>
    </Wrapper>
  )
}

export default Customers

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const CustomersArea = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  row-gap: 24px;
`

const Customer = styled.div`
  img {
    width: 252px;
    height: 66px;
    border: 1px solid #e2e2e2;
    display: flex;
  }
`
